<template>
  <div class="image-container">
    <img class="product-img" v-if="image" :src="image ? image.image_url : ''" :class="{ order: isOrder }">
    <div v-else>
      {{ $t('ChargingPillarImage.no_image_available') }}{{ currentBuild }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ChargingPillarImage',
  props: {
    isOrder: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      image: 'images/getBuildImage',
      device: 'getDevice',
    }),
    currentBuild() {
      const getters = this.$store.getters;
      const build = this.$store.state.build;

      let name = '';
      name += getters['types/current'] ? getters['types/current'].name : '';
      name += ' ' + (build.double ? 'Dubbel' : 'Enkel');

      return name;
    },
  },
};
</script>

<style scoped lang="scss">
.image-container {
  padding: 10px;

  .product-img {
    max-width: 100%;
    height: auto;
    max-height: 100%;

    &.order {
      max-height: 140px !important;
    }
  }
}
</style>
